export default "__VITE_ASSET__C32YQfpp__"